let E400 = "400: Solicitud incorrecta, contacte a un administrador.";
let E403 = "403: No tiene acceso al servicio, contacte a un administrador.";
let E404 = "404: El servicio no se encuenstra disponible, inténtelo más tarde.";
let E500 = "500: Error de código, contacte a un administrador.";
let E504 = "504: Se agotó el tiempo de espera.";
let E509 = "509: Se ha superado el límite de ancho de banda.";
let otro = "Hay un error con el servicio, contacte a un administrador";

const mensajes = {
  E400,
  E403,
  E404,
  E500,
  E504,
  E509,
  otro,
};

export default mensajes;

